import { defineAsyncComponent } from 'vue'

// const SettingLayout = defineAsyncComponent(() =>
//   import(/*webpackChunkName:'settinglayout'*/ '@/views/common/SettingLayout.vue')
// );
const FileViewerPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName:'FileViewerPopup' */ '@/components/fileViewer/popup')
)

export function registerCommonPopup (app) {
  app.component('FileViewer', FileViewerPopup)
}
